import imageCompression from "browser-image-compression"

import {UploadParkNoteImage} from '@/graphql/mutations/ParkNote.graphql'

export default {
  data(){
    return {
      imageCompressionOption  : {
        maxSizeMB         : 1,
        maxWidthOrHeight  : 1920,
        useWebWorker      : true
      },

      imageUploadLimit        : 3,

      couldAttachImages       : false,

      inputImagesBlob         : [],
      inputImagesDataURL      : [],
      uploadedImagesURL       : [],

      isDisabledUploader  : false
    };
  },

  methods : {
    getImageMBSize(size){
      return (size / 1024 / 1024) + 'Mb';
    },

    isImageBlob(obj){
      return (obj instanceof Blob);
    },

    executeUploadImage(resizedFile){
      return new Promise((resolve) => {
        this.$apollo.mutate({
          mutation  : UploadParkNoteImage,
          variables : {
            image : resizedFile
          }
        }).then(async ({data:{UploadParkNoteImage}}) => {
          resolve(UploadParkNoteImage.imageURL);
        }).catch(async (error) => {
          const simpleErrorSet = this.getApolloSimpleErrorFromApolloError(error);

          if(typeof simpleErrorSet.firstError.field !== 'undefined'){
            this.$store.dispatch({
              type        : 'flashMessage/updateFlashMessage',
              hasMessage  : true,
              message     : '&nbsp;'+simpleErrorSet.firstError.message,
              status      : 'error',
              hasControl  : true,
              autoClose   : 3000
            }, {root:true});
          }

          resolve(false);
        });
      });
    },

    async imageResize(imageFile){
      if(!this.isImageBlob(imageFile)) return imageFile;

      try {
        return await imageCompression(imageFile, this.imageCompressionOption);
      } catch (error) {
        console.error("getCompressImageFileAsync is error", error);
        // throw error;
        return imageFile;
      }
    },

    executeInputImage(file){
      return new Promise((resolve) => {
        const reader = new FileReader();

        reader.onload = async (event) => {
          // プレビュー用の画像を先に登録します。
          this.inputImagesDataURL.push(event.target.result);

          this.inputImagesBlob.push( await this.imageResize(file) );

          resolve(true);
        }
  
        // 入力されたファイルをDATAURLに変換して取得します。
        reader.readAsDataURL(file);
      });
    },

    async handleChangeImageUploaderFileField(event){
      this.$store.dispatch({
        type  : 'parkNote/updateIsEditorLoading',
        value : true,
      });
      // this.isEditorLoading = true;

      this.initializeImageUpload();

      let files = event.target.files || event.dataTransfer.files;

      if(typeof files[0] === 'undefined') return;

      // 画像の縮小等を行います。
      for(let i = 0; i < files.length; i++){
        await this.executeInputImage(files[i]);
      }

      // 処理される画像の数が制限を超える場合は配列をsplitしてreduceします。
      this.validateImageCount();

      // アップロード処理を実行します。
      for(let i = 0; i < this.inputImagesBlob.length; i++){
        const imageURL = await this.executeUploadImage(this.inputImagesBlob[i]);
        
        this.uploadedImagesURL.push(imageURL);
      }

      // Quillに挿入します。
      for(let i = 0; i < this.uploadedImagesURL.length; i++){
        const index = (this.quill.getSelection() || {}).index || this.quill.getLength();
        this.quill.insertEmbed(index, 'image', this.uploadedImagesURL[i], 'user');
      }
      
      this.initializeImageUpload(true);

      // this.isEditorLoading = false;
      this.$store.dispatch({
        type  : 'parkNote/updateIsEditorLoading',
        value : false,
      });
    },

    initializeImageUpload(cleanup = false){
      this.inputImagesDataURL = [];
      this.inputImagesBlob    = [];
      this.uploadedImagesURL  = [];

      if(cleanup){
        this.$refs.imageFileInput.value = null;
      }
    },

    validateImageCount(){
      if(this.inputImagesBlob.length > this.imageUploadLimit){
        this.inputImagesBlob    = this.inputImagesBlob.slice(0, this.imageUploadLimit);
        this.inputImagesDataURL = this.inputImagesDataURL.slice(0, this.imageUploadLimit);
        this.uploadedImagesURL  = this.uploadedImagesURL.slice(0, this.imageUploadLimit);

        const jpFullWidthLimit = this.$options.filters.mutateFullWidth(this.imageUploadLimit);

        this.$store.dispatch({
          type        : 'flashMessage/updateFlashMessage',
          hasMessage  : true,
          message     : '&nbsp;一度にアップロードできる画像は'+jpFullWidthLimit+'つまでで御座います。',
          status      : 'error',
          hasControl  : true,
          autoClose   : 3000
        }, {root:true});
      }
    }
  }
}